var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { ToastServiceContext } from './ToastServiceContext';
export const ToastServiceProvider = ({ children }) => {
    _react_refresh_temp_2();
    const [toasts, setToasts] = useState([]);
    const [toastContainer, setToastContainer] = useState(null);
    const value = useMemo(() => {
        return {
            setToastContainer,
            setToasts,
            toastContainer,
            toasts,
        };
    }, [toastContainer, toasts]);
    return (_jsx(ToastServiceContext.Provider, { value: value, children: children }));
};
_react_refresh_temp_1 = ToastServiceProvider;
$RefreshReg$(_react_refresh_temp_1, "ToastServiceProvider");
_react_refresh_temp_2(ToastServiceProvider, "q9xk/MXfj4rosHm8yFvNEBwXfHA=");
